<template>
  <div v-if="storedCustomer && apiUser && apiUser.isCustomerAdmin" class="admin-page__content">
    <form>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h2 class="mb-0">
            {{ $t("sluzbyALimity") }}
          </h2>
          {{ $t("proZakaznika") }} {{ storedCustomer.customerName }}
        </div>
        <!--button
          class="btn btn-primary d-flex align-items-center justify-content-center">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg">
          </div>
          {{ $t("ulozitZmeny") }}
        </button-->
      </div>
    </form>
    <div class="mt-4">
      <RadioHelp
        :article-link="'/admin/customer/services-limits'"
        :show="showHelp"
        @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
        @update-show-radio-help="showRadioHelp($event)"
      />
      <div class="d-flex flex-wrap mt-3 mb-2 position-relative">
        <button
          :disabled="!selectedRows || selectedRows.length == 0"
          class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center mr-2 mb-2"
          @click="toggleAppendModal('appendService')"
        >
          {{ $t("priraditProjektu") }}
        </button>
        <button
          :disabled="!selectedRows || selectedRows.length == 0"
          class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
          @click="toggleRemoveModal('removeService')"
        >
          {{ $t("odebratProjektu") }}
        </button>

        <RadioOpenClose
          :custom-class="'d-flex align-items-end radio--default'"
          :radio-slides="radioSlides"
          :show="showHelp"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <CustomTable
        :columns="[
          { name: 'custServiceName', sortable: true, action: 'openModal1' },
          { name: 'custServiceId', sortable: true },
          { name: 'tarifName', sortable: true },
          { name: 'devices.count', sortable: true },
          { name: 'custState', sortable: true }
        ]"
        :item-id="'custServiceId'"
        :items="services"
        :kebab="false"
        :loading="loading"
        class="services"
        full-width
        selectable
        single-selectable
        @opened="openItem"
        @open-modal1="openServiceDetail"
        @selected-rows="setRows"
      >
        <!--template #actions="{runAction}">
          <div class="dropdown-actions__item d-flex align-items-center" @click="runAction('detail')">
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg">
              </div>
              {{ $t("detail") }}
          </div>
        </template-->
      </CustomTable>
    </div>
    <div v-if="openedDetail.length > 0">
      <ServiceDetail
        :opened="openedDetail"
        :service="selectedService"
        @close-box="toggleDetailModal"
        @open-box="toggleDetailModal"
      />
    </div>
    <div v-if="openedAppend.length > 0">
      <AppendToProject
        :opened="openedAppend"
        :services="selectedRows"
        @close-box="toggleAppendModal"
        @open-box="toggleAppendModal"
      />
    </div>
    <div v-if="openedRemove.length > 0">
      <RemoveFromProject
        :opened="openedRemove"
        :services="selectedRows"
        @close-box="toggleRemoveModal"
        @open-box="toggleRemoveModal"
      />
    </div>
    <div v-if="openedDetailSim.length > 0">
      <ServiceSimDetail
        :opened="openedDetailSim"
        :service="selectedService"
        @close-box="toggleDetailServiceModal"
        @open-box="toggleDetailServiceModal"
      />
    </div>
  </div>
  <div v-else>
    {{ $t("nemateOpravneniProhlizetTutoStranku") }}
  </div>
</template>

<script>
import axios from "axios"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import customTable from "@/components/custom-table/table.vue"
import ServiceDetail from "@/components/modals/admin/customer/service.vue"
import AppendToProject from "@/components/modals/admin/customer/appendService.vue"
import RemoveFromProject from "@/components/modals/admin/customer/removeService.vue"
import ServiceSimDetail from "@/components/modals/admin/customer/serviceSim.vue"
import { useConfigStore } from "@/store/modules/config"
import { useCustomerStore } from "@/store/modules/customer"
import { useAuthStore } from "@/store/modules/auth"

export default {
  components: {
    CustomTable: customTable,
    RadioHelp,
    RadioOpenClose,
    AppendToProject,
    RemoveFromProject,
    ServiceDetail,
    ServiceSimDetail
  },
  props: {
    customer: Object
  },
  setup() {
    const configStore = useConfigStore()
    const customerStore = useCustomerStore()
    const authStore = useAuthStore()

    return { configStore, customerStore, authStore }
  },
  data() {
    return {
      radioSlides: [],
      loading: false,
      showHelp: true,
      services: [],
      openedItem: {},
      selectedRows: [],
      openedDetail: [],
      selectedService: {},
      openedAppend: [],
      openedRemove: [],
      openedDetailSim: []
    }
  },
  computed: {
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    apiUser() {
      return this.authStore.apiUser
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    storedCustomer() {
      this.loadServices()
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.showHelp = !this.radioDisabled
    if (this.storedCustomer) {
      this.loadServices()
    }
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    loadServices() {
      this.loading = true
      this.services = []
      axios
        .get(process.env.VUE_APP_API + "/customers/" + this.storedCustomer.customerId + "/services?limit=200")
        .then((result) => {
          this.services = result.data.data
          for (let i = 0; i < result.data.data.length; i++) {
            if (result.data.data[i].suspended == true || result.data.data[i].discontinued == true) {
              result.data.data[i].notSelectable = true
              result.data.data[i].customRowClass = "gray-text-light"
            }

            if (result.data.data[i].suspended == false && result.data.data[i].discontinued == false) {
              result.data.data[i].custState = "Aktivní"
            } else if (result.data.data[i].suspended == true && result.data.data[i].discontinued == false) {
              result.data.data[i].custState = "Suspendovaná"
            } else if (result.data.data[i].discontinued == true) {
              result.data.data[i].custState = "Deaktivní"
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    openItem(item) {
      this.openedItem = item
    },
    setRows(rows) {
      this.selectedRows = rows
    },
    toggleRemoveModal(box) {
      if (this.openedRemove.indexOf(box) > -1) {
        box == undefined ? (this.openedRemove = []) : this.openedRemove.splice(this.openedRemove.indexOf(box), 1)
      } else {
        this.openedRemove.push(box)
      }
    },
    toggleAppendModal(box) {
      if (this.openedAppend.indexOf(box) > -1) {
        box == undefined ? (this.openedAppend = []) : this.openedAppend.splice(this.openedAppend.indexOf(box), 1)
      } else {
        this.openedAppend.push(box)
      }
    },
    toggleDetailModal(box) {
      if (this.openedDetail.indexOf(box) > -1) {
        box == undefined ? (this.openedDetail = []) : this.openedDetail.splice(this.openedDetail.indexOf(box), 1)
      } else {
        this.openedDetail.push(box)
      }
    },
    toggleDetailServiceModal(box) {
      if (this.openedDetailSim.indexOf(box) > -1) {
        box == undefined
          ? (this.openedDetailSim = [])
          : this.openedDetailSim.splice(this.openedDetailSim.indexOf(box), 1)
      } else {
        this.openedDetailSim.push(box)
      }
    },
    openServiceDetail(item) {
      this.selectedService = item
      let isSim = this.selectedService.productElementId == "s_iot8681"
      if (isSim) {
        this.openedDetailSim.push("serviceDetail")
      } else {
        this.openedDetail.push("serviceDetail")
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
